import { useUpcomingEvents } from '@features/landing/grandprix/hooks/useUpcomingEvents';
import { LandingSectionTitle } from '@features/landing/shared/ui/components/LandingSectionTitle';
import {
  LINK_GRANDPRIX_TOURNAMENT_RULES_BLITZ,
  LINK_GRANDPRIX_TOURNAMENT_RULES_RAPID,
  LINK_GRANDPRIX_TOURNAMENTS_BLITZ,
  LINK_GRANDPRIX_TOURNAMENTS_RAPID,
} from '@features/chessrussian/customizations/constants';
import styles from './GrandPrixUpcomingTournaments.module.css';
import { LandingButton } from '@features/landing/shared/ui/components/LandingButton';
import { Loader } from '@ui/components/Loader';
import { TournamentDetailsRow } from '@features/landing/shared/ui/components/TournamentDetailsRow';
import { LandingChip } from '@features/landing/shared/ui/components/LandingChip';
import { ClockControl } from '@features/landing/shared/ui/components/ClockControl';
import { RoundsCount } from '@features/landing/shared/ui/components/RoundsCount';
import { TournamentSystem } from '@features/landing/shared/ui/components/TournamentSystem';
import { TZDate } from '@date-fns/tz';
import { DateView, TimeView } from '@ui/components/DateView';
import { NonMobileBr } from '@features/landing/shared/ui/components/Br/Br';
import { useMediaQuery } from '@providers/MediaQueryProvider';

export function GrandPrixUpcomingTournaments() {
  const { blitz, rapid, isLoading } = useUpcomingEvents();

  const device = useMediaQuery();
  const chipSize =
    device === 'tablet' || device === 'mobile' ? 'large' : 'medium';

  return (
    <>
      <LandingSectionTitle>Ближайшие турниры серии</LandingSectionTitle>

      {isLoading && (
        <div className={styles.loader}>
          <Loader centered />
        </div>
      )}

      {blitz && (
        <TournamentDetailsRow
          title="Блиц"
          tags={
            <>
              <LandingChip size={chipSize}>
                <ClockControl tournament={blitz} />
              </LandingChip>
              <LandingChip size={chipSize}>
                <RoundsCount tournament={blitz} />
              </LandingChip>
              <LandingChip size={chipSize}>
                <TournamentSystem tournament={blitz} />
              </LandingChip>
            </>
          }
          date={
            <>
              <DateView
                date={new TZDate(blitz.startTimestampMs, 'Europe/Moscow')}
              />
              &nbsp;
              <NonMobileBr />
              <TimeView
                date={new TZDate(blitz.startTimestampMs, 'Europe/Moscow')}
              />{' '}
              МСК
            </>
          }
          statement={
            <LandingButton href={LINK_GRANDPRIX_TOURNAMENT_RULES_BLITZ}>
              Положение
              <br />о турнире&nbsp;›
            </LandingButton>
          }
          link={
            <LandingButton
              href={LINK_GRANDPRIX_TOURNAMENTS_BLITZ}
              size="22m-40"
              color="active-faded"
            >
              Турниры&nbsp;›
            </LandingButton>
          }
        />
      )}

      {rapid && (
        <TournamentDetailsRow
          title="Рапид"
          tags={
            <>
              <LandingChip size={chipSize}>
                <ClockControl tournament={rapid} />
              </LandingChip>
              <LandingChip size={chipSize}>
                <RoundsCount tournament={rapid} />
              </LandingChip>
              <LandingChip size={chipSize}>
                <TournamentSystem tournament={rapid} />
              </LandingChip>
            </>
          }
          date={
            <>
              <DateView
                date={new TZDate(rapid.startTimestampMs, 'Europe/Moscow')}
              />
              &nbsp;
              <NonMobileBr />
              <TimeView
                date={new TZDate(rapid.startTimestampMs, 'Europe/Moscow')}
              />{' '}
              МСК
            </>
          }
          statement={
            <LandingButton href={LINK_GRANDPRIX_TOURNAMENT_RULES_RAPID}>
              Положение
              <br />о турнире&nbsp;›
            </LandingButton>
          }
          link={
            <LandingButton
              href={LINK_GRANDPRIX_TOURNAMENTS_RAPID}
              size="22m-40"
              color="active-faded"
            >
              Турниры&nbsp;›
            </LandingButton>
          }
        />
      )}
    </>
  );
}
